import React, { useEffect, useState } from "react";
import { buildVersion } from "../services/buildInfo";

function ThankYou() {
  const [executed, setExecuted] = useState(false);

  useEffect(() => {
    window.adobeDataLayer = window.adobeDataLayer || [];
    // Setting Page Level and user-specific variables
    window.adobeDataLayer.push({
      event: "pageView",
      web: {
        webPageDetails: {
          pageViews: {
            value: 1,
          },
          name: "icicibank:in:en:campaign:accounts:casa:savingsaccount:onboarding:eligible thankyou page",

          URL: window.location.href,
          isErrorPage: "False",
        },
      },
      _icicibank: {
        channelInfo: {
          version: buildVersion,
          name: "nli",
        },
        pageInfo: {
          language: "en",
          country: "in",
          pageType: "campaign",
          virtualPageView: "no vpv",
          journey: "na",
          subJourney: "na",
          subSubJourney: "na",
        },
        userInfo: {
          userType: "na",
        },
        errorInfo: {
          errorType: "na",
          errorDetails: "na",
        },
      },
    });
  }, []);

  // Google Ads gtag — Remarketing (AW-961178487, AW-848956189, AW-736858127, AW-11185178531) + Conversion (AW-736858127)
  // useEffect(() => {
  //   if (document.getElementById("gtag-remarketing")) return;

  //   window.dataLayer = window.dataLayer || [];
  //   function gtag() { window.dataLayer.push(arguments); }
  //   window.gtag = gtag;

  //   const script = document.createElement("script");
  //   script.id = "gtag-remarketing";
  //   script.async = true;
  //   script.src = "https://www.googletagmanager.com/gtag/js?id=AW-961178487";
  //   document.head.appendChild(script);

  //   gtag("js", new Date());

  //   // Remarketing configs
  //   gtag("config", "AW-961178487");
  //   gtag("config", "AW-848956189");
  //   gtag("config", "AW-736858127");
  //   gtag("config", "AW-11185178531");

  //   // Conversion event
  //   gtag("event", "conversion", { send_to: "AW-736858127/r6u3CN_v1J4YEI-grt8C" });
  // }, []);


  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = "https://www.googletagmanager.com/gtag/js?id=DC-8971752";
  //   script.async = true;
  //   document.head.appendChild(script);

  //   script.onload = () => {
  //     window.dataLayer = window.dataLayer || [];
  //     function gtag() {
  //       window.dataLayer.push(arguments);
  //     }
  //     window.gtag = window.gtag || gtag;
  //     window.gtag("js", new Date());
  //     window.gtag("config", "DC-8971752");
  //     window.gtag("event", "conversion", {
  //       allow_custom_scripts: true,
  //       send_to: "DC-8971752/invmedia/saving03+standard",
  //     });
  //   };
  // }, []);

  // useEffect(() => {
  //   if (document.getElementById("gtag-remarketing")) return;

  //   window.dataLayer = window.dataLayer || [];
  //   function gtag() { window.dataLayer.push(arguments); }
  //   window.gtag = gtag;

  //   const userData = localStorage.getItem("userData");
  //   const retrievedData = userData ? JSON.parse(userData) : null;

  //   const script = document.createElement("script");
  //   script.id = "gtag-remarketing";
  //   script.async = true;
  //   script.src = "https://www.googletagmanager.com/gtag/js?id=AW-961178487";
  //   document.head.appendChild(script);

  //   script.onload = () => {
  //     gtag("js", new Date());

  //     // Remarketing configs
  //     gtag("config", "AW-961178487");
  //     gtag("config", "AW-848956189");
  //     gtag("config", "AW-11185178531", { send_page_view: true });

  //     // Manually fire page_view for the two that aren't auto-firing
  //     window.gtag("event", "Page View", { send_to: "AW-11185178531" });
  //     window.gtag("event", "Page View", { send_to: "AW-736858127" });

  //     // ECL on AW-736858127
  //     if (retrievedData?.mobile) {
  //       gtag("set", "user_data", { phone_number: retrievedData.mobile });
  //     }
  //     gtag("config", "AW-736858127", { allow_enhanced_conversions: true, send_page_view: true });

  //     // Conversion event
  //     gtag("event", "conversion", { send_to: "AW-736858127/r6u3CN_v1J4YEI-grt8C" });

  //     // Form submit event
  //     gtag("event", "form_submit", { send_to: "AW-736858127" });
  //   };

  //   // Remove userData from localStorage after 4 seconds using a separate function
  //   function removeUserData() {
  //     localStorage.removeItem("userData");
  //   }
  //   setTimeout(removeUserData, 4000);
  // }, []);


  useEffect(() => {
    const userData = localStorage.getItem("userData");
    const retrievedData = userData ? JSON.parse(userData) : null;

    const fireGtags = () => {
      if (!window.gtag) {
        setTimeout(fireGtags, 300);
        return;
      }

      window.gtag("js", new Date());

      // Remarketing configs
      window.gtag("config", "AW-961178487", { send_page_view: true });
      window.gtag("config", "AW-848956189", { send_page_view: true });
      window.gtag("config", "AW-736858127", { send_page_view: true });

      // Manually fire page_view for the two that aren't auto-firing
      window.gtag("event", "Page View", { send_to: "AW-11185178531" });
      window.gtag("event", "Page View", { send_to: "AW-736858127" });

      // ECL on AW-11185178531
      if (retrievedData?.mobile) {
        window.gtag("config", "AW-736858127", { allow_enhanced_conversions: true, send_page_view: true });
        window.gtag("set", "user_data", { phone_number: retrievedData.mobile });
      } else {
        window.gtag("config", "AW-736858127", { send_page_view: true });
      }

      // DV 360 config
      window.gtag("config", "DC-8971752");

      // Conversion events
      window.gtag("event", "conversion", { send_to: "AW-736858127/r6u3CN_v1J4YEI-grt8C" });
      window.gtag("event", "form_submit", { send_to: "AW-736858127" });

      // DV 360 Floodlight conversion
      window.gtag("event", "conversion", {
        allow_custom_scripts: true,
        send_to: "DC-8971752/invmedia/saving03+standard",
      });

      setTimeout(() => localStorage.removeItem("userData"), 4000);
    };

    fireGtags();
  }, []);

  // Facebook Pixel — Remarketing (PageView) + Conversion (SA-ApplyNow)
  useEffect(() => {
    if (window.fbThankYouFired) return; // 👈 separate flag for thankyou
    window.fbThankYouFired = true;

    const fireFbq = () => {
      if (!window.fbq) {
        setTimeout(fireFbq, 300);
        return;
      }

      window.fbq("init", "1109423764622443");
      window.fbq("track", "PageView");
      window.fbq("trackCustom", "SA-ApplyNow");  // Conversion
    };

    fireFbq();
  }, []);

  // LinkedIn Insight Tag — partner ID 5534113
  useEffect(() => {
    const fireLinkedIn = () => {
      if (!window.lintrk) {
        setTimeout(fireLinkedIn, 300);
        return;
      }
      window.lintrk("track"); // fires page view on thankyou
    };
    fireLinkedIn();
  }, []);

  // Bing UET Tags — 97231495 and 97231496
  useEffect(() => {
    if (document.getElementById("bing-uet")) return;

    window.uetq = window.uetq || [];
    window.uetq2 = window.uetq2 || [];

    const script = document.createElement("script");
    script.id = "bing-uet";
    script.src = "https://bat.bing.com/bat.js";
    script.async = true;
    script.onload = () => {
      window.uetq = new window.UET({ ti: "97231495", q: window.uetq });
      window.uetq.push("pageLoad");

      window.uetq2 = new window.UET({ ti: "97231496", q: window.uetq2 });
      window.uetq2.push("pageLoad");
    };
    document.body.appendChild(script);
  }, []);

  // MS Clarity — vn9y1utxz2
  useEffect(() => {
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "vn9y1utxz2");
  }, []);

  return (
    <>

      {/* <LinkedInTag/> */}
      <article className="thankyou_sec">
        <div className="container ">
          <div className="tick">
            <img
              src="../dist/img/tick.webp"
              alt="tick"
              width="100"
              height="100"
              className="img-fluid"
            />
          </div>
          {/* <div className="thankyou_txt">
            <p>
              Thank You for your interest in
              <br className="d-block " /> ICICI 3-in-1 Account.
              <br className="d-md-none d-block" />
              {" "}  We are assessing your eligibility, and
              <br className="d-block" /> our representative will get in touch with you shortly from a number starting with 1600 31 XXXX{" "}
            </p>
          </div> */}
          <div className="thankyou_txt">
            <p>
              Thank you for your interest in the ICICI 3-in-1 Savings Account. Your submission is complete.
            </p>
            <p>
              We are currently reviewing your details to ensure that we provide you with the most relevant options for your profile.
            </p>
            <p>
              If applicable, one of our representatives will contact you shortly from a number starting with 1600 31 XXXX to take things forward.
            </p>
          </div>
        </div>
      </article>
    </>
  );
}

export default ThankYou;
